import { BE_DOMAIN } from '../env'

export class baseServiceExportExcel {
  getAccessToken = () => {
    const root = JSON.parse(localStorage.getItem('persist:root') || '{}')
    const auth = root?.auth ? JSON.parse(root.auth) : null
    return auth?.data?.user?.accessToken || ''
  }

  get = async (url, inAccessToken) => {
    try {
      const accessToken = inAccessToken ? inAccessToken : this.getAccessToken()

      const response = await fetch(`${BE_DOMAIN}/${url}`, {
        method: 'GET',
        headers: {
          Authorization: accessToken ? `Bearer ${accessToken}` : '',
        },
      })

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
      }

      return response
    } catch (error) {
      throw error
    }
  }
  post = async (url, data, inAccessToken) => {
    try {
      const accessToken = inAccessToken ? inAccessToken : this.getAccessToken()
      const response = await fetch(`${BE_DOMAIN}/${url}`, {
        method: 'POST',
        headers: {
          Authorization: accessToken ? `Bearer ${accessToken}` : '',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
      }
      return response
    } catch (error) {
      throw error
    }
  }
}
